import request from '../../utils/request';

/**
 * Admin RemoteLock per-order access API (backend: /api/v1/admin/remotelock/orders/*).
 * All calls are admin-authenticated by the shared request client.
 */

const BASE = '/admin/remotelock';

export const getOrderAccessState = (orderId, config) =>
  request.get(`${BASE}/orders/${orderId}/access`, config).then((r) => r.data);

export const provisionOrderAccess = (orderId, { startsAt, endsAt }) =>
  request.post(`${BASE}/orders/${orderId}/access`, { startsAt, endsAt }).then((r) => r.data);

export const revealOrderAccessPin = (orderId) =>
  request.post(`${BASE}/orders/${orderId}/access/reveal-pin`).then((r) => r.data);

export const revokeAccess = (accessId) =>
  request.post(`${BASE}/accesses/${accessId}/revoke`).then((r) => r.data);

export const fetchOrderAccessSummary = (orderIds) =>
  request.post(`${BASE}/orders/access-summary`, { orderIds }).then((r) => r.data?.orders || {});

/** Human copy for backend availability reasons. */
export const AVAILABILITY_COPY = {
  no_mapping: 'No smart lock is mapped to this property yet. The host maps a door under Integrations → RemoteLock.',
  no_connection: 'The host has not connected RemoteLock.',
  connection_needs_reauth: 'The host must reconnect RemoteLock (authorization expired).',
  connection_disconnected: 'The host disconnected RemoteLock.',
  connection_pending: 'RemoteLock connection is still pending on the host side.',
  order_terminal: 'This order is completed or cancelled.',
};

export const availabilityMessage = (reason) => {
  if (!reason) return null;
  if (AVAILABILITY_COPY[reason]) return AVAILABILITY_COPY[reason];
  if (reason.startsWith('order_status_')) return `Order status "${reason.replace('order_status_', '')}" cannot receive access yet.`;
  return `Smart lock access unavailable (${reason}).`;
};

export const parseApiError = (err, fallback = 'Request failed') => {
  const data = err?.response?.data;
  if (data?.message) return data.message;
  if (typeof data === 'string') return data;
  if (err?.response?.status === 503) return 'RemoteLock integration is disabled on the server.';
  return err?.message || fallback;
};
